import addressToString from './addressToString'

export const handleDirectionByAddress = async departmentAddress => {
  try {
    if (typeof departmentAddress === 'string') {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${departmentAddress}`
      )
    } else {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${addressToString(departmentAddress)}`
      )
    }
  } catch (err) {
    console.log('open map error', err)
  }
}

export const handleDirectionByCoordinates = (longitude, latitude) => {
  window.open('https://maps.google.com?q=' + latitude + ',' + longitude)
}

export const getDirectionUrl = location => {
  if (location?.address) {
    return 'https://maps.google.com?q=' + location.address
  }
}

export const handleCall = phone => window.open(`tel:${phone}`)
